var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSiteGroup(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 100,
    height: 100,
    fill: "none",
    viewBox: "0 0 192 192",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#1C71B8",
    d: "M96 18a60 60 0 0 0-60 60c0 54 60 96 60 96s60-42 60-96a59.997 59.997 0 0 0-60-60Zm0 84a24.004 24.004 0 0 1-22.173-14.816A24 24 0 1 1 96 102Z",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#1C71B8",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 12,
    d: "M96 102c13.255 0 24-10.745 24-24s-10.745-24-24-24-24 10.745-24 24 10.745 24 24 24Z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#1C71B8",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 12,
    d: "M156 78c0 54-60 96-60 96s-60-42-60-96a60 60 0 1 1 120 0v0Z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#1C71B8",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 6,
    d: "M29.5 114c-5.799 0-10.5 4.701-10.5 10.5S23.701 135 29.5 135c3.11 0 5.904-1.352 7.826-3.5"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#1C71B8",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 6,
    d: "M48 147.904C40.198 159.5 29.5 167 29.5 167S3 148.423 3 124.538a26.558 26.558 0 0 1 7.762-18.765A26.491 26.491 0 0 1 22.294 99M162.5 114c5.799 0 10.5 4.701 10.5 10.5s-4.701 10.5-10.5 10.5c-3.11 0-5.904-1.352-7.826-3.5"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#1C71B8",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 6,
    d: "M144 147.904C151.802 159.5 162.5 167 162.5 167s26.5-18.577 26.5-42.462a26.557 26.557 0 0 0-7.762-18.765A26.489 26.489 0 0 0 169.706 99"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSiteGroup);
export default __webpack_public_path__ + "static/media/SiteGroup.9fc7079390c986ddd7bc355c5c3764e0.svg";
export { ForwardRef as ReactComponent };